import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { PaymentAjaxService } from "../payment-system/services/payment-ajax.service";
import { AjaxService } from "./ajax.service";
import { BannerService } from "./banner.service";
import { EmitterService } from "./emitter.service";
import { SocketService } from "./socket.service";

@Injectable({
    providedIn: 'root'
})
export class PnpZimplerService {

    withdrawlFeesDetails;
    constructor(private ajaxService: AjaxService,
        private emitterService: EmitterService,
        private socketService: SocketService,
        private bannerService: BannerService,
        private ajaxPaymentService: PaymentAjaxService) {

    }

    private initiateDeposit = new BehaviorSubject<any>(null);
    public initiateDespoit$ = this.initiateDeposit.asObservable();

    broadCastInitiateDeposit(data) {
        this.initiateDeposit.next(data);
    }

    private initiateLogin = new BehaviorSubject<any>(null);
    public initiateLogin$ = this.initiateLogin.asObservable();

    broadCastInitiateLogin(txnType) {
        this.initiateLogin.next(txnType);
    }

    private initQuickDeposit = new BehaviorSubject<any>(null);
    public initQuickDeposit$ = this.initQuickDeposit.asObservable();

    broadCastInitQuickDeposit(data) {
        this.initQuickDeposit.next(data);
    }

    openZimplerDeposit() {
        this.broadCastInitiateDeposit({ callingFrom: 'deposit' });
        this.broadCastInitiateLogin('DEPOSIT');
        this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "open" });
    }

    openZimplerLogin() {
        this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "open" });
        this.broadCastInitiateLogin('LOGIN');
    }
    setWithdrwalFeesDetails(cashOutData:any,paymentMode){
        let feeObj = {
         maxFee:0,
         minFee:0,
         fee:0,
         isPercentage:false,
         feeType:""
        }
        if(cashOutData.cashierData && cashOutData.cashierData.cashoutMethods && cashOutData.cashierData.cashoutMethods[paymentMode] &&cashOutData.cashierData.cashoutMethods[paymentMode].limits){
            let feesInfo = cashOutData.cashierData.cashoutMethods[paymentMode].limits;
            feeObj.isPercentage = feesInfo.feeType == 'absolute' ? false : true;
            feeObj.minFee = feesInfo.minFeeAmount;
            feeObj.maxFee = feesInfo.maxFeeAmount;
            feeObj.fee = feesInfo.feeAmount;
            feeObj.feeType = feesInfo.feeType;
        }
        
        this.setWithdrawlFeeDetails(feeObj);
  }
    setWithdrawlFeeDetails(withdrawlFeesDetails) {
        this.withdrawlFeesDetails = withdrawlFeesDetails;
        this.emitterService.broadCastWithdrawlFeesDetails(true);
    }
    getWithdrawlFeeDetails() {
       return this.withdrawlFeesDetails;
    }

    depositLimits = {
        minLimit: 0,
        maxLimit: 0
    }
    getPNPMinMaxTxnLimits(minMaxRequestData): Promise<any> {
        return this.ajaxService.getPNPMinMaxTxnLimits(minMaxRequestData).then(response => {
            if (response['status'] === 'SUCCESS' && response["minMaxTxnLimitsData"]
                && response["minMaxTxnLimitsData"][0]) {
                this.depositLimits = {
                    minLimit: response["minMaxTxnLimitsData"][0]['minTxnLimit'],
                    maxLimit: response["minMaxTxnLimitsData"][0]['maxTxnLimit']
                }
            }
            return this.depositLimits
        });
    }

    zimplerPayAndPlayInit(initRequestData) {
        return this.ajaxService.zimplerPayAndPlayInit(initRequestData);
    }

    getPNPUserFromTransaction(transactionData): Promise<any> {
        return this.ajaxService.getPNPUserFromTransaction(transactionData);
    }
    depositPayAndPlayInit(initRequestData,countryIP) {
        if(environment.semiPnpZimplerCountries.indexOf(countryIP) >= 0 || environment.zimplerPnp.indexOf(countryIP) >= 0){
            return this.ajaxService.zimplerPayAndPlayInit(initRequestData);
        }
        return this.ajaxService.britePayAndPlayInit(initRequestData);
    }

    quickRegisterMode(transactionData, countryIP): Promise<any> {
        if(environment.semiPnpZimplerCountries.indexOf(countryIP) >= 0 || environment.zimplerPnp.indexOf(countryIP) >= 0){
            return this.ajaxService.quickRegisterZimpler(transactionData);
        }
        return this.ajaxService.quickRegisterBrite(transactionData);
    }

    getPNPThirdPartyLogin(transactionData): Promise<any> {
        return this.ajaxService.getthirdPartyLogin(transactionData).
            then(response => {
                if (response && response["status"] === "SUCCESS") {
                    this.socketService.connectToScoket(response['pragmaticUrl'], response['pragmaticSessionId']);
                    sessionStorage.setItem("user", 'true');
                    this.emitterService.broadcastloginComplete("loginsuccess");
                    localStorage.setItem("loginstatus", "true");
                    this.bannerService.clearBanners();
                }
                return response
            });
    }
    /** Withdraw code goes here */

    private initiateWithDraw = new BehaviorSubject<any>(null);
    public initiateWithDraw$ = this.initiateWithDraw.asObservable();

    broadCastInitiateWithDraw(data) {
        this.initiateWithDraw.next(data);
    }

    openZimplerWithDraw() {
        this.broadCastInitiateWithDraw({ callingFrom: 'withdraw' });
        this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "open" ,cashierType:"withdrawal"});
    }

    zimplerWithdrawInit(withdrawRequestData) {
        return this.ajaxPaymentService.makewithdraw(withdrawRequestData)
    }

    getUserPSPTranstionStatus(data): Observable<any> {
        return this.ajaxPaymentService.getTransactionStatus(data)
    }

    cashOutLimits = {
        minLimit: 0,
        maxLimit: 0
    }
    getPaymentMethod(userCountry){
        let paymentMethod = "";
        if(environment.semiPnpZimplerCountries.indexOf(userCountry) >= 0 || environment.zimplerPnp.indexOf(userCountry) >= 0){
            paymentMethod = "ZIMPLER_DIRECT";
        }else if(environment.zimplerCountries.indexOf(userCountry) >= 0){
            paymentMethod = "BRITEPLAY";
        }
        return paymentMethod;
      }
    getCashoutTxnLimits(requestData,userCountry): Observable<any> {
        if(userCountry){
            return this.ajaxPaymentService.getCashierData(requestData).pipe(map(response => {
                let paymentMode = this.getPaymentMethod(userCountry);
                this.setWithdrwalFeesDetails(response,paymentMode);
                if (response && response['cashierData'] && response['cashierData']['cashoutMethods']) {
                    let cashoutData = response['cashierData']['cashoutMethods'][paymentMode];
                    if(cashoutData['limits']['minTxnLimit'] && cashoutData['limits']['maxTxnLimit'])
                    {
                        this.cashOutLimits = {
                            minLimit: parseInt(cashoutData['limits']['minTxnLimit']),
                            maxLimit: parseInt(cashoutData['limits']['maxTxnLimit'])
                        }
                    }else{
                        this.cashOutLimits = {
                            minLimit: 0,
                            maxLimit: 0
                        }
                    }
                }
                return this.cashOutLimits;
            }));
        }
       
    }

    getPendingCashOuts(pendingWithdrawalObject?): Promise<any> {
        return this.ajaxService.getPendingCashOuts(pendingWithdrawalObject);
    }
}